//import { AbstractControl, FormGroup } from "@angular/forms";
// export function ConfirmedValidator(controlName: string, matchingControlName: string) {
//     return (formGroup: FormGroup) => {
//       let control = formGroup.controls[controlName];
//       let matchingControl = formGroup.controls[matchingControlName]
//       if (
//         matchingControl.errors &&
//         !matchingControl.errors.confirmedValidator
//       ) {
//         return;
//       }
//       if (control.value !== matchingControl.value) {
//         matchingControl.setErrors({ confirmedValidator: true });
//       } else {
//         matchingControl.setErrors(null);
//       }
//     };
//   }
import {FormControl, FormGroup} from '@angular/forms'
export class ConfirmedValidator {

    // static OldPasswordMustBeCorrect(control: FormControl) {
    //     var invalid = false;
    //     if (control.value != ConfirmedValidator.oldPW)
    //         return { oldPasswordMustBeCorrect: true }
    //     return null;
    // }
   
    // Our cross control validators are below
    // NOTE: They take in type FormGroup rather than FormControl 
    // static newIsNotOld(group: FormGroup){
    //     var newPW = group.controls['password'];
    //     if(group.controls['oldpassword'].value == newPW.value)
    //         newPW.setErrors({ newIsNotOld: true });
    //     return null;
    // }

    static newMatchesConfirm(group: FormGroup){
        var confirm = group.controls['cpassword'];
        if(group.controls['password'].value !== confirm.value)
            confirm.setErrors({ newMatchesConfirm: true });
        return null;
    }

    // static MeasureStrength(pass: string) {  
    //     let score = 0;  
    //     // award every unique letter until 5 repetitions  
    //     let letters = {};  
    //     for (let i = 0; i< pass.length; i++) {  
    //     letters[pass[i]] = (letters[pass[i]] || 0) + 1;  
    //     score += 5.0 / letters[pass[i]];  
    //     }  
    //     // bonus points for mixing it up  
    //     let variations = {  
    //     digits: /\d/.test(pass),  
    //     lower: /[a-z]/.test(pass),  
    //     upper: /[A-Z]/.test(pass),  
    //     nonWords: /\W/.test(pass),  
    //     };  
    //     let variationCount = 0;  
    //     for (let check in variations) {  
    //     variationCount += (variations[check]) ? 1 : 0;  
    //     }  
    //     score += (variationCount - 1) * 10;  
    //     return Math.trunc(score);  
    //     }  
}